var render, staticRenderFns
import script from "./babyaudiolist.vue?vue&type=script&lang=js"
export * from "./babyaudiolist.vue?vue&type=script&lang=js"
import style0 from "./babyaudiolist.vue?vue&type=style&index=0&id=22f7ea92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7ea92",
  null
  
)

export default component.exports